import React from 'react';
import styles from './CountryInfo.module.css';

export interface InfoRowProps {
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
}

const InfoRow: React.FC<InfoRowProps> = ({ icon, label, value }) => (
  <div className={styles.infoRow}>
    <span className={styles.infoRowIcon}>{icon}</span>
    <div className={styles.infoRowText}>
      <div className={styles.infoRowLabel}>{label}</div>
      <div className={styles.infoRowValue}>{value}</div>
    </div>
  </div>
);

export default InfoRow;
